import * as fromDatatype from '../datatype-library'


export interface bl_asv_consultation_checklist_image_line_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    checklist_type: fromDatatype.VarcharDatatypeInterface;
    hdr_guid: fromDatatype.GuidDataFieldInterface;
    description: fromDatatype.VarcharDatatypeInterface;
    app_file_guid: fromDatatype.GuidDataFieldInterface;
    url_key: fromDatatype.GuidDataFieldInterface;
    namespace:fromDatatype.VarcharDatatypeInterface;
    file_name:fromDatatype.VarcharDatatypeInterface;
    file_size:fromDatatype.VarcharDatatypeInterface;
    extension:fromDatatype.VarcharDatatypeInterface;
    mime_type:fromDatatype.VarcharDatatypeInterface;
    file_type:fromDatatype.VarcharDatatypeInterface;
    file_code:fromDatatype.VarcharDatatypeInterface;
    value_file:fromDatatype.VarcharDatatypeInterface;
    value_string:fromDatatype.VarcharDatatypeInterface;
    property_json:fromDatatype.JsonDatatypeInterface;
    acl_config:fromDatatype.JsonDatatypeInterface;
    acl_policy:fromDatatype.JsonDatatypeInterface;
    module_guid:fromDatatype.GuidDataFieldInterface;
    applet_guid:fromDatatype.GuidDataFieldInterface;
    created_by_subject_guid:fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid:fromDatatype.GuidDataFieldInterface
    created_date:fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    revision: fromDatatype.RevisionDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
    status: fromDatatype.StatusDataFieldInterface;
}

export class bl_asv_consultation_checklist_image_line_RowClass implements bl_asv_consultation_checklist_image_line_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    checklist_type: fromDatatype.VarcharDatatypeInterface;
    hdr_guid: fromDatatype.GuidDataFieldInterface;
    description: fromDatatype.VarcharDatatypeInterface;
    app_file_guid: fromDatatype.GuidDataFieldInterface;
    url_key: fromDatatype.GuidDataFieldInterface;
    namespace:fromDatatype.VarcharDatatypeInterface;
    file_name:fromDatatype.VarcharDatatypeInterface;
    file_size:fromDatatype.VarcharDatatypeInterface;
    extension:fromDatatype.VarcharDatatypeInterface;
    mime_type:fromDatatype.VarcharDatatypeInterface;
    file_type:fromDatatype.VarcharDatatypeInterface;
    file_code:fromDatatype.VarcharDatatypeInterface;
    value_file:fromDatatype.VarcharDatatypeInterface;
    value_string:fromDatatype.VarcharDatatypeInterface;
    property_json:fromDatatype.JsonDatatypeInterface;
    acl_config:fromDatatype.JsonDatatypeInterface;
    acl_policy:fromDatatype.JsonDatatypeInterface;
    module_guid:fromDatatype.GuidDataFieldInterface;
    applet_guid:fromDatatype.GuidDataFieldInterface;
    created_by_subject_guid:fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid:fromDatatype.GuidDataFieldInterface
    created_date:fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    revision: fromDatatype.RevisionDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
    status: fromDatatype.StatusDataFieldInterface;
}
